export default "__VITE_ASSET__DcGHQLOW__"